module.exports = __webpack_public_path__ + "img/bg1.4553d1c6.jpg";